import { ChangeDetectionStrategy, Component, Inject, inject } from '@angular/core';

import { NDT_SNACK_BAR_DATA } from '../snack-bar/snack-bar-config';
import { NdtSnackBarRef } from '../snack-bar/snack-bar-ref';
import { NotificationData } from './notification.interface';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationComponent {
  readonly snackBarRef = inject(NdtSnackBarRef<NotificationComponent>);

  constructor(@Inject(NDT_SNACK_BAR_DATA) readonly data: NotificationData) {}

  /** If the action button should be shown. */
  get hasAction(): boolean {
    return !!this.data.actions;
  }
}
